// TB-093: the clinic and the doctor app share routes (/doctor/my-earnings,
// /doctor/payouts, ...). An establishment in clinic mode gets the clinic page;
// a doctor, and a clinic viewing one of its doctors ("View Details"), keep the
// doctor page (TB-092). The choice is made on every visit, not cached by the
// router, so switching account or mode in the same tab is safe.
import { h, defineAsyncComponent, defineComponent, provide } from 'vue'
import { currentRole } from '@/layouts/components/app-shell/navModel'

export function isEstView () {
  return currentRole() === 'establishment'
}

export function estOr (doctorLoader, estLoader, name = 'EstOrDoctor') {
  const Doctor = defineAsyncComponent(doctorLoader)
  const Est = defineAsyncComponent(estLoader)
  return defineComponent({
    name,
    inheritAttrs: false,
    setup (_, { attrs }) {
      const est = isEstView()
      return () => h(est ? Est : Doctor, attrs)
    }
  })
}

// W7: clinic version of a shared page that TB-092 rebuilt on the list kit. The
// legacy frame restyles old markup and breaks the kit (double header, card
// padding stripped), so the clinic gets the TB-092 page itself; its
// PageHeader shows the clinic subtitle instead of the doctor one.
export const EST_SUBTITLE_KEY = 'tbEstSubtitle'

export function estDirect (loader, { subtitle = '' } = {}) {
  const Inner = defineAsyncComponent(loader)
  return () => Promise.resolve(defineComponent({
    name: 'EstDirectPage',
    inheritAttrs: false,
    setup (_, { attrs }) {
      provide(EST_SUBTITLE_KEY, subtitle)
      return () => h(Inner, attrs)
    }
  }))
}

// Route guard that applies to the doctor page only.
export function skipForEstView (guard) {
  return (...args) => (isEstView() ? true : guard(...args))
}
